/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 * @description Utility functions related to the ui-router library.
 */

/**
 * Symbol used by ui-router to annotate that a state is lazy-loaded.
 */
const UI_ROUTER_WILDCARD = '.**';

/**
 * Strip the ui-router wildcard/future state symbol (.**) from the end of state names. This is used
 * when trying to redirect to a registered state that may be lazy-loaded. $state.target cannot point
 * to a wildcard state name.
 */
export function removeWildcard(stateName: string): string {
    const wildcardPosition = stateName.indexOf(UI_ROUTER_WILDCARD);

    if (
        wildcardPosition > -1 &&
        stateName.length - wildcardPosition === UI_ROUTER_WILDCARD.length
    ) {
        return stateName.replace(UI_ROUTER_WILDCARD, '');
    }

    return stateName;
}
